var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Components, CustomElement, CustomElementUtils, CustomEventUtils, Defaults, P, PCSS, PropertyConverters, stopPropagationHandler, Utils, ViewChild, Watch } from '@pacem/pacem-core';
import { Components as ComponentsUI } from '@pacem/pacem-ui';
import { PacemBaseElement } from './types-components';
//namespace Pacem.Components.Scaffolding {
const JsonOrStringConverter = {
    convert: (attr, el) => {
        return /\{.+\}/.test(attr) ? PropertyConverters.Json.convert(attr) : PropertyConverters.String.convert(attr);
    },
    convertBack: (prop, el) => {
        if (typeof prop === 'string') {
            return prop;
        }
        return PropertyConverters.Json.convertBack(prop, el);
    }
};
// #region MONTH-PICKER (util component)
function buildMonthGrid() {
    let header = '';
    for (let month = 0; month < 12; month++) {
        header += `<div class="calendar-month month-${month + 1}"><${P}-span class="month-button text-ellipsed" on-click=":host._setMonth(${month})" css-class="{{ { 'selected-month': :host._isSelectedMonth(${month}, :host.month, :host.viewYear), 'this-month': :host._isThisMonth(${month}, :host.viewYear) } }}" text="{{ :host._getMonthLabel(${month}) }}"></${P}-span></div>`;
    }
    return header;
}
let PacemCalendarMonthPickerElement = class PacemCalendarMonthPickerElement extends Components.PacemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'viewYear':
                this.dispatchEvent(new CustomEvent('viewyearchange', { detail: new Date(val, 0, 1), bubbles: false, cancelable: false }));
                Utils.removeClass(this, "viewyear-next viewyear-previous");
                requestAnimationFrame(() => {
                    Utils.addClass(this, old > val ? "viewyear-previous" : "viewyear-next");
                });
                break;
        }
    }
    _getMonthLabel(m) {
        const year = new Date().getFullYear();
        const date = new Date(year, m, 1);
        return date.toLocaleString(Utils.lang(this), { month: 'short' });
    }
    _isThisMonth(m, v = this.viewYear) {
        return this._isSelectedMonth(m, new Date(), v);
    }
    _isSelectedMonth(m, d = this.month, v = this.viewYear) {
        const actual = Utils.parseDate(d);
        if (!Utils.Dates.isDate(actual)) {
            return false;
        }
        const viewYear = v ?? new Date().getFullYear();
        return actual.getMonth() === m && actual.getFullYear() === viewYear;
    }
    _setMonth(m) {
        const year = this.viewYear;
        const date = new Date(year, m, 1);
        this.month = date;
        this.dispatchEvent(new CustomEvent('monthselect', { detail: date, bubbles: false, cancelable: false }));
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Date })
], PacemCalendarMonthPickerElement.prototype, "month", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Date })
], PacemCalendarMonthPickerElement.prototype, "viewYear", void 0);
PacemCalendarMonthPickerElement = __decorate([
    CustomElement({
        tagName: P + '-calendar-month-picker', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-month-picker">${buildMonthGrid()}</div>`
    })
], PacemCalendarMonthPickerElement);
export { PacemCalendarMonthPickerElement };
export class CalendarDateUnselectEvent extends ComponentsUI.UI.DateSelectEvent {
    constructor() {
        super(void 0);
    }
}
// #endregion
// #region YEAR-PICKER (util component)
const YEARS_IN_RANGE = 12;
function buildYearGrid() {
    let header = '';
    for (let year = 0; year < YEARS_IN_RANGE; year++) {
        header += `<div class="calendar-year year-${year + 1}"><${P}-span class="year-button text-ellipsed" on-click=":host._setYear(${year})" css-class="{{ { 'selected-year': :host._isSelectedYear(${year}, :host.year, :host.viewYear), 'this-year': :host._isThisYear(${year}, :host.viewYear) } }}" text="{{ :host._getYearLabel(${year}, :host.viewYear) }}"></${P}-span></div>`;
    }
    return header;
}
function rangeFirstYear(y) {
    const mod = y % 10;
    return y - mod;
}
let PacemCalendarYearPickerElement = class PacemCalendarYearPickerElement extends Components.PacemElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'viewYear':
                this.dispatchEvent(new CustomEvent('viewyearchange', { detail: new Date(val, 0, 1), bubbles: false, cancelable: false }));
                Utils.removeClass(this, "viewyear-next viewyear-previous");
                requestAnimationFrame(() => {
                    Utils.addClass(this, old > val ? "viewyear-previous" : "viewyear-next");
                });
                break;
        }
    }
    _getYearLabel(y, year = this.viewYear) {
        const first = rangeFirstYear(year);
        return '' + (first + y);
    }
    _isThisYear(y, v = this.viewYear) {
        return this._isSelectedYear(y, new Date(), v);
    }
    _isSelectedYear(y, d = this.year, v = this.viewYear) {
        const actual = Utils.parseDate(d);
        if (!Utils.Dates.isDate(actual)) {
            return false;
        }
        const start = rangeFirstYear(v), computed = start + y;
        ;
        return actual.getFullYear() === computed;
    }
    _setYear(y) {
        const v = this.viewYear, first = rangeFirstYear(v);
        const date = new Date(first + y, 0, 1);
        this.year = date;
        this.dispatchEvent(new CustomEvent('yearselect', { detail: date, bubbles: false, cancelable: false }));
    }
};
__decorate([
    Watch({ converter: PropertyConverters.Date })
], PacemCalendarYearPickerElement.prototype, "year", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Date })
], PacemCalendarYearPickerElement.prototype, "viewYear", void 0);
PacemCalendarYearPickerElement = __decorate([
    CustomElement({
        tagName: P + '-calendar-year-picker', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-year-picker">${buildYearGrid()}</div>`
    })
], PacemCalendarYearPickerElement);
export { PacemCalendarYearPickerElement };
// #endregion
function buildCalendarHeader() {
    let header = '';
    for (let day = 0; day < 7; day++) {
        header += `<${P}-span class="calendar-heading day-${day + 1} text-ellipsed" text="{{ :host._getHeaderLabel(:host._week[${day}]) }}"></${P}-span>`;
    }
    return `<${P}-panel hide="{{ :host.viewmode !== 'calendar' }}" class="calendar-header">${header}</${P}-panel>`;
}
let PacemCalendarPickerElement = class PacemCalendarPickerElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        this.viewmode = 'calendar';
        this.#locked = false;
        this._swipeHandler = (e) => {
            const dir = e.detail.direction;
            switch (dir) {
                case 'left':
                    this._next(e);
                    break;
                case 'right':
                    this._prev(e);
                    break;
            }
        };
        this._clearBtnHandler = (evt) => {
            evt.preventDefault();
            this._viewDate = new Date();
            this.changeHandler(new CalendarDateUnselectEvent());
        };
        this._viewDateChangeHandler = (e) => {
            this._onViewDateChange(e);
        };
        this._popCalendarHandler = (e) => {
            if (this.#locked) {
                return;
            }
            this.viewmode = 'calendar';
            const dateValue = Utils.parseDate(this.value);
            this._calendar.viewDate =
                this._monthPicker.month =
                    this._yearPicker.year =
                        Utils.Dates.isDate(dateValue) ? dateValue : this._calendar.viewDate;
            const offset = Utils.offset(this._input);
            const dropdown = this._dropdown;
            dropdown.style.top = (offset.top + offset.height) + 'px';
            dropdown.style.left = offset.left + 'px';
            dropdown.hidden = false;
            requestAnimationFrame(() => {
                Utils.addClass(dropdown, 'dropdown-in');
            });
        };
        this._hideCalendarHandler = (e) => {
            const path = e.composedPath() || [];
            if (path.indexOf(this._input) >= 0 || path.indexOf(this._dropdown) >= 0) {
                return;
            }
            this._hideCalendar();
        };
    }
    #locked;
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'viewmode':
            case '_viewDate':
                this._onViewDateChange(this._viewDate);
                break;
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const dropdown = this._dropdown = this._proxy.dom[0];
        const calendar = this._calendar = dropdown.querySelector(P + '-calendar');
        const monthPicker = this._monthPicker = dropdown.querySelector(P + '-calendar-month-picker');
        const yearPicker = this._yearPicker = dropdown.querySelector(P + '-calendar-year-picker');
        this._monthLabel = dropdown.querySelector('.calendar-month');
        this._yearLabel = dropdown.querySelector('.calendar-year');
        this._rangeLabel = dropdown.querySelector('.calendar-year-range');
        const now = this._calendar.now = new Date();
        const dateValue = Utils.Dates.parse(this.value);
        const hasValue = Utils.Dates.isDate(dateValue);
        const date = hasValue ? dateValue : now;
        calendar.dayLabelFormatter = (d) => {
            return Utils.parseDate(d).toLocaleString(Utils.lang(this), { day: 'numeric' });
        };
        monthPicker.addEventListener('viewyearchange', this._viewDateChangeHandler, false);
        yearPicker.addEventListener('viewyearchange', this._viewDateChangeHandler, false);
        calendar.addEventListener('viewdatechange', this._viewDateChangeHandler, false);
        calendar.viewDate = date;
        calendar.date = dateValue;
        const input = this._input;
        input.addEventListener('focus', this._popCalendarHandler, false);
        input.addEventListener('mousedown', this._popCalendarHandler, false);
        dropdown.addEventListener('mousedown', stopPropagationHandler, false);
        window.document.body.addEventListener('mousedown', this._hideCalendarHandler, true);
        this._clearButton.addEventListener('mousedown', this._clearBtnHandler, false);
        // swiper
        const swiper = new Components.PacemSwipeElement();
        calendar.behaviors.push(swiper);
        monthPicker.behaviors.push(swiper);
        yearPicker.behaviors.push(swiper);
        swiper.addEventListener('swipe', this._swipeHandler, false);
        const body = CustomElementUtils.findAncestorShell(this);
        this._swiper = body.appendChild(swiper);
    }
    disconnectedCallback() {
        const input = this._input;
        if (!Utils.isNull(input)) {
            this._clearButton.removeEventListener('mousedown', this._clearBtnHandler, false);
            input.removeEventListener('focus', this._popCalendarHandler, false);
            input.removeEventListener('mousedown', this._popCalendarHandler, false);
            this._dropdown.removeEventListener('mousedown', stopPropagationHandler, false);
            window.document.body.removeEventListener('mousedown', this._hideCalendarHandler, true);
            this._calendar.removeEventListener('viewdatechange', this._viewDateChangeHandler, false);
            this._monthPicker.removeEventListener('viewyearchange', this._viewDateChangeHandler, false);
            this._yearPicker.removeEventListener('viewyearchange', this._viewDateChangeHandler, false);
        }
        const swiper = this._swiper;
        if (!Utils.isNull(swiper)) {
            const calendar = this._calendar, monthPicker = this._monthPicker, yearPicker = this._yearPicker;
            for (let el of [calendar, monthPicker, yearPicker]) {
                const behaviors = el.behaviors, swipeIndex = behaviors.indexOf(swiper);
                if (swipeIndex >= 0) {
                    el.behaviors.splice(swipeIndex, 1);
                }
            }
            swiper.removeEventListener('swipe', this._swipeHandler, false);
            swiper.remove();
            this._swiper = null;
        }
        super.disconnectedCallback();
    }
    _getHeaderLabel(d, mode = this.viewmode) {
        const dte = Utils.parseDate(d);
        if (Utils.Dates.isDate(dte)) {
            return dte.toLocaleString(Utils.lang(this), { weekday: 'narrow' });
        }
        return '...';
    }
    _prev(e) {
        let months = -1;
        switch (this.viewmode) {
            case 'month':
                months = -12;
                break;
            case 'year':
                months = -120;
                break;
        }
        this._jumpMonths(months);
    }
    _next(e) {
        let months = 1;
        switch (this.viewmode) {
            case 'month':
                months = 12;
                break;
            case 'year':
                months = 120;
                break;
        }
        this._jumpMonths(months);
    }
    _jumpMonths(m) {
        const vd = Utils.parseDate(this._viewDate);
        this._viewDate = Utils.Dates.addMonths(vd, m);
    }
    _setMonth(e) {
        this._viewDate = e.detail;
        this.viewmode = 'calendar';
    }
    _setYear(e) {
        this._viewDate = e.detail;
        this.viewmode = 'month';
    }
    _onViewDateChange(e) {
        if (Utils.isNullOrEmpty(e)) {
            return;
        }
        const date = Utils.parseDate(this._viewDate);
        if (Utils.Dates.isDate(date) && !Utils.isNull(this._monthLabel)) {
            switch (this.viewmode) {
                case 'month':
                    this._yearLabel.text = date.toLocaleString(Utils.lang(this), { year: 'numeric' });
                    break;
                case 'year':
                    const fy = rangeFirstYear(date.getFullYear());
                    this._rangeLabel.text = `${fy} - ${fy + YEARS_IN_RANGE - 1}`;
                    break;
                default:
                    this._monthLabel.text = date.toLocaleString(Utils.lang(this), { month: 'long', year: 'numeric' });
                    break;
            }
        }
    }
    _hideCalendar() {
        // animation just in case
        Utils.removeClass(this._dropdown, 'dropdown-in');
        Utils.addAnimationEndCallback(this._dropdown, e => {
            this._dropdown.hidden = true;
            Utils.removeClass(this._dropdown, 'dropdown-select');
        }, 250);
    }
    get inputFields() {
        return [this._input];
    }
    toggleReadonlyView(readonly) {
        if (this.isReady) {
            this._input.readOnly = true;
            this._input.hidden = readonly;
            this._span.hide = !readonly;
        }
    }
    onChange(evt) {
        return new Promise((resolve, reject) => {
            if (CustomEventUtils.isInstanceOf(evt, ComponentsUI.UI.DateSelectEvent)) {
                Utils.addClass(this._dropdown, 'dropdown-select');
                const unselecting = CustomEventUtils.isInstanceOf(evt, CalendarDateUnselectEvent);
                if (unselecting) {
                    this.#locked = true;
                }
                this.focus();
                this.#locked = false;
                this._hideCalendar();
                resolve(this.value = evt.detail);
            }
            else {
                resolve(this.value);
            }
        });
    }
    acceptValue(val) {
        this._input.value = this.viewValue;
        const calendar = this._calendar;
        if (!Utils.isNull(calendar)) {
            const dateVal = Utils.parseDate(val);
            if (Utils.Dates.isDate(dateVal)) {
                calendar.viewDate = calendar.date = dateVal;
            }
            else {
                calendar.date = void 0;
            }
        }
    }
    getViewValue(value) {
        const v = Utils.Dates.parse(value);
        if (Utils.Dates.isDate(v)) {
            return Utils.core.date(v, this.format || 'short', Utils.lang(this));
        }
        return '';
    }
    compareValuePropertyValues(old, val) {
        const dold = Utils.parseDate(old), dval = Utils.parseDate(val);
        if (Utils.isNullOrEmpty(dold) && Utils.isNullOrEmpty(dval)) {
            return true;
        }
        if (Utils.isNullOrEmpty(dold) || Utils.isNullOrEmpty(dval)) {
            return false;
        }
        return dold.valueOf() == dval.valueOf();
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Datetime.convert(attr);
    }
};
__decorate([
    ViewChild("input[type=text]")
], PacemCalendarPickerElement.prototype, "_input", void 0);
__decorate([
    ViewChild(`.${PCSS}-readonly`)
], PacemCalendarPickerElement.prototype, "_span", void 0);
__decorate([
    ViewChild(`${P}-button[clear]`)
], PacemCalendarPickerElement.prototype, "_clearButton", void 0);
__decorate([
    ViewChild(P + "-shell-proxy")
], PacemCalendarPickerElement.prototype, "_proxy", void 0);
__decorate([
    Watch({ emit: false, converter: JsonOrStringConverter })
], PacemCalendarPickerElement.prototype, "format", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Eval })
], PacemCalendarPickerElement.prototype, "disabledRanges", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemCalendarPickerElement.prototype, "weekStart", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemCalendarPickerElement.prototype, "viewmode", void 0);
__decorate([
    Watch()
], PacemCalendarPickerElement.prototype, "_week", void 0);
__decorate([
    Watch()
], PacemCalendarPickerElement.prototype, "_viewDate", void 0);
PacemCalendarPickerElement = __decorate([
    CustomElement({
        tagName: P + '-calendar-picker', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-calendar-picker">
    <input type="text" class="${PCSS}-input" /><${P}-span text="{{ :host.viewValue }}" class="${PCSS}-readonly"></${P}-span>
    <${P}-button class="button-flat ${PCSS}-anim anim-pop anim-sudden anim-quick pos-absolute absolute-right absolute-top display-block ${PCSS}-margin margin-0"
                 tab-order="-1"
                 hide="{{ :host.readonly || :host.required || !Pacem.Utils.Dates.isDate(Pacem.Utils.Dates.parse(:host.value)) }}"
                 icon-glyph="close"
                 clear></${P}-button>
</div>
<${P}-shell-proxy>
    <div class="${PCSS}-calendar-picker-dropdown" pacem hidden>
        <${P}-collapse collapse="false">
            <div class="dropdown-grid">
                <div class="calendar-title">
                    <${P}-span class="calendar-month calendar-zoom" on-click=":host.viewmode = 'month'" hide="{{ :host.viewmode !== 'calendar' }}"></${P}-span>
                    <${P}-span class="calendar-year calendar-zoom" on-click=":host.viewmode = 'year'" hide="{{ :host.viewmode !== 'month' }}"></${P}-span>
                    <${P}-span class="calendar-year-range" hide="{{ :host.viewmode !== 'year' }}"></${P}-span>
                </div>
                <div class="calendar-month-nav ${PCSS}-buttonset buttons">
                    <div class="buttonset-left">
                        <${P}-button class="button button-size size-auto" on-click=":host._prev($event)" icon-glyph="chevron_left"></${P}-button>
                        <${P}-button class="button button-size size-auto" on-click=":host._next($event)" icon-glyph="chevron_right"></${P}-button>
                    </div>
                </div>
                ${buildCalendarHeader()}
                <${P}-calendar hide="{{ :host.viewmode !== 'calendar' }}" week="{{ :host._week, twoway }}" view-date="{{ :host._viewDate, twoway }}" week-start="{{ :host.weekStart }}" disabled-ranges="{{ :host.disabledRanges }}" on-dateselect="{{ :host.changeHandler($event) }}"></${P}-calendar>
                <${P}-calendar-month-picker hide="{{ :host.viewmode !== 'month' }}" on-monthselect=":host._setMonth($event)" month="{{ :host.value || Date.now() }}" view-year="{{ :host._viewDate && :host._viewDate.getFullYear() }}"></${P}-calendar-month-picker>
                <${P}-calendar-year-picker hide="{{ :host.viewmode !== 'year' }}" on-yearselect=":host._setYear($event)" year="{{ :host.value || Date.now() }}" view-year="{{ :host._viewDate && :host._viewDate.getFullYear() }}"></${P}-calendar-year-picker>
            </div>
        <${P}-collapse>
    </div>
</${P}-shell-proxy>`
    })
], PacemCalendarPickerElement);
export { PacemCalendarPickerElement };
